import axios 					from 'axios';
import {isUndefined, has} 		from 'lodash-es';
import ObservableService 		from '../ObservableService';
import NotificationService 		from '../NotificationService';
import DataStorage              from '@Helpers/DataStorage';
import { navigateTo } from '@Services/navigation';

const baseUrl = `${process.env.API_URL}`;

const requestParams = {
	headers: {
		'Accept': 'application/json',
	},
	baseURL: baseUrl,
};

const requestPutParams = {
	headers: {
		'Accept': 'application/json',
	},
	baseURL: baseUrl,
};

const setAuthHeaders = (config) => {
	const token = DataStorage.getData('token');
	config.headers.Authorization = `Bearer ${token}`;

	return config;
};

const checkInternalServerError =  (error) => {
	if (!has(error, 'response')) {
		return error = {
			response: {
				data: 'Cancel request'
			}
		}
	}
};

const checkAuthServerError =  (status, logout) => {
	if (!isUndefined(status) && status === 401) {
		logout();
		navigateTo('home');
	}
};

const renderServerError = (status, data = {}) => {
	if ([500, 503, 504].includes(status)) {
		ObservableService.emit('renderServerErrorPopup', data);
	}
};

const interceptorsResponse = (service, logout) => {
	service?.interceptors.response.use((response) => {
		return response;
	}, (error) => {
		if (!has(error, 'response')) {
			error = {
				response: {
					data: 'Cancel request'
				}
			}
		}

		checkInternalServerError(error);
		checkAuthServerError(error.response.status, logout);

		let data = error.response.config?.data ?? {};

		if(error.response.config?.headers?.['Content-Type']?.indexOf('application/x-www-form-urlencoded') !== -1) {
			data = {response: error.response.config?.data ?? ''}
		}

		renderServerError(error.response.status, {
			url: error.response.config.url,
			method: error.response.config.method,
			data: data,
			request: error.response.data,
		});

		if (error.response.status === 400) {
			if (error.response?.data?.error) {
				NotificationService.errors(error.response.data.error);
			}
		}

		if (error.response.status === 404) {
			if (error.response?.data) {
				NotificationService.error({
					title: 'error',
					message: error.response?.data
				});
				
			}
		}

		return Promise.reject(error);
	});
};

const simpleRequest = axios.create(requestParams);
const securedRequest = axios.create(requestParams);
const securedPutRequest = axios.create(requestPutParams);

securedRequest.interceptors.request.use(setAuthHeaders, null);
securedPutRequest.interceptors.request.use(setAuthHeaders, null);


simpleRequest.interceptors.response.use((response) => {
	return response;

}, (error) => {
	checkInternalServerError(error);

	return Promise.reject(error);
});

export const initRequestInterceptors = (logout) => {
	interceptorsResponse(securedRequest, logout);
	interceptorsResponse(securedPutRequest, logout);
};

export { simpleRequest, securedRequest, securedPutRequest };
